module.exports = __webpack_public_path__ + "static/media/staff_default_avatar.f96dd417.svg";